<template>
  <div>
    <page-header
      :actions="pageHeaderActionsConfig"
      :page="pageHeaderConfig"
      right-side-class="col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
    />

    <search-references
      v-if="isAdding && !isStudentSelected"
      @onSelect="onSelectStudent"
    />

    <div v-if="(isAdding && isStudentSelected) || isDetailsView">
      <historial-umers :student="student" />
    </div>

    <div v-if="(isAdding && isStudentSelected) || isDetailsView" class="mt-3">
      <validation-observer ref="umers">
        <general-info
          ref="generalInfo"
          :data="records"
          :disabled="readOnly"
          @change="onChangeGeneralInfo"
        />
        <div class="mt-3">
          <documents
            v-model="documents"
            :auto-upload="isDetailsView"
            :available-document-types="documentTypes"
            :disabled="readOnly"
            :on-download="this.onDownload"
            :unique-document-type="true"
            @isValid="isDocumentValid"
            @onRemove="onRemoveDocuments"
            @onUpload="editionDocumentsUpload"
          />
        </div>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import { serialize as objectToFormData } from 'object-to-formdata';
import alertMixin from 'utils/mixins/alert.mixin';
import SearchReferences from './components/SearchReferences';
import Documents from './components/Documents';
import HistorialUmers from './components/HistorialUMERS';
import GeneralInfo from './components/GeneralInfo';
import { ValidationObserver } from 'vee-validate';
import service from '@/modules/app/api';
import {
  createUmesrFindings,
  removeUmesrFindingsById,
  getUmesrFindingsById,
  getDocumentTypes,
  updateUmesrFindings,
  createUmesrFindingsDocuments,
  deleteUmesrFindingsDocuments,
} from '@/modules/umesr/api';

const recordsDefault = {
  reasonId: null,
  comment: '',
  reason: null,
  status: {},
};

export default {
  name: 'UmesrCRUD',
  components: {
    GeneralInfo,
    SearchReferences,
    Documents,
    HistorialUmers,
    ValidationObserver,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: [Number, String],
      default: 0,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    records: { ...recordsDefault },
    student: null,
    documentTypes: [],
    documents: [],
  }),
  computed: {
    pageHeaderConfig() {
      const routes = ['Proveedor', 'Historial de Hallazgos UMESR'];

      if (this.isAdding) {
        routes.push('Añadir Hallazgos');
      }

      if (this.isDetailsView) {
        routes.push('Detalle del Hallazgo de UMESR');
      }

      if (this.isEditing) {
        routes.push('Editar');
      }

      return {
        title: 'Hallazgo UMESR',
        icon: 'fas fa-user-tie',
        routes,
      };
    },
    readOnly() {
      return (
        (this.isDetailsView && this.isViewDetailsMode) ||
        (!this.isDetailsView && !this.isAdding)
      );
    },
    isDetailsView() {
      return !this.isAdding;
    },
    isStudentSelected() {
      return Boolean(this.student);
    },
    isViewDetailsMode() {
      return this.isDetailsView && !this.isEditing;
    },
    isAdding() {
      return this.id == 0;
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: this.goBackSearch,
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          click: this.saveHandler,
          visible: (this.isAdding && this.isStudentSelected) || this.isEditing,
        },
      ];
    },
  },
  watch: {
    id() {
      if (this.id) {
        this.getDetails();
      }
    },
  },
  created() {
    if (this.id) {
      this.getDetails();
    }
    getDocumentTypes().then((res) => {
      this.documentTypes = res.data;
    });
  },
  methods: {
    isDocumentValid(item) {
      if (item) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
      }
    },
    async getDetails() {
      // init student
      this.student = {};

      if (!(this.id != undefined && this.id != 0)) {
        return false;
      }
      await getUmesrFindingsById(this.id)
        .then(({ data }) => {
          this.records = {
            ...data,
            studentServiceMonitoringId:
              data.studentServiceMonitoringId || this.id,
          };
          this.documents = data.documents.map((d) => {
            return {
              documentType: {
                id: d.documentTypeId,
                name: d.documentTypeName,
              },
              documentId: d.documentId,
              fileName: d.documentName,
            };
          });
          this.student = { ...data.student };
        })
        .catch((error) => {
          this.ShowToast('Alerta', error.response.data.message, 'error');
        });
    },
    onSelectStudent(student) {
      if (student) {
        this.student = {
          ...student,
        };
      }
    },
    onChangeGeneralInfo(generalInfo) {
      this.records = {
        ...this.records,
        ...generalInfo,
      };
    },
    async onDeleteHandler() {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar el hallazgo?',
        'Si',
        'No'
      );
      if (!answer) {
        return;
      }

      await removeUmesrFindingsById(this.id)
        .then(() => {
          this.goBackSearch();
        })
        .catch((error) => {
          this.ShowToast('Alerta', error.response.data.message, 'error');
        });
    },
    async cancelHandler() {
      this.isEditing = false;
      this.documents = [];
      await this.getDetails();
    },
    async validateUmesr() {
      const umesrDetailsFormGeneralInfo = this.$refs.umers;

      const areValid = (
        await Promise.all([umesrDetailsFormGeneralInfo.validate()])
      ).reduce((c, n) => c && n);

      return areValid;
    },
    async saveHandler() {
      const isValid = await this.validateUmesr();

      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      if (this.id) {
        return await this.updateUmesr();
      }

      this.createUmers();
    },
    async updateUmesr() {
      const {
        studentServiceMonitoringId,
        admissionId,
        findingDate,
        reasonId,
        comment,
      } = this.records;

      const formData = {
        studentServiceMonitoringId,
        admissionId: admissionId ? admissionId : this.student.admissionId,
        findingDate,
        reasonId,
        comment,
      };

      await updateUmesrFindings(this.id, formData)
        .then(() => {
          this.ShowToast(
            '',
            'Los datos fueron guardados exitosamente.',
            'success'
          );
          this.isEditing = false;
        })
        .catch((error) => {
          this.ShowToast('Alerta', error.response.data.message, 'error');
        });
    },
    async createUmers() {
      const {
        studentServiceMonitoringId,
        admissionId,
        findingDate,
        reasonId,
        comment,
      } = this.records;

      const formData = objectToFormData(
        {
          studentServiceMonitoringId,
          admissionId: admissionId ? admissionId : this.student.admissionId,
          findingDate,
          reasonId,
          comment,
          documents: this.documents.map((d) => ({
            file: d.attachment,
            documentTypeId: d.documentType.id,
          })),
        },
        { indices: true, nullsAsUndefineds: true }
      );

      await createUmesrFindings(formData)
        .then((res) => {
          this.ShowToast(
            'Proceso exitoso',
            'Los datos fueron guardados exitosamente.',
            'success'
          );
          this.$router.push({
            name: 'UmesrDetails',
            params: { id: res.data.studentServiceMonitoringId },
          });
        })
        .catch((error) => {
          this.ShowToast('Alerta', error.response.data.message, 'error');
        });
    },
    async onDownload(documentId) {
      if (documentId != undefined) {
        service.downloadDocumentByAttachmentId(documentId);
      }
    },
    goBackSearch() {
      this.$router.push({
        name: 'UmesrSearch',
      });
    },
    async editionDocumentsUpload(item) {
      const { studentServiceMonitoringId } = this.records;
      await createUmesrFindingsDocuments(
        studentServiceMonitoringId,
        objectToFormData(
          {
            file: item.attachment,
            documentTypeId: item.documentType.id,
          },
          { indices: true, nullsAsUndefineds: true }
        )
      ).catch((error) => {
        this.ShowToast('Alerta', error.response.data.message, 'error');
      });
    },
    async onRemoveDocuments(item) {
      await deleteUmesrFindingsDocuments(item.documentId)
        .then(() => {
          this.ShowToast(
            'Proceso exitoso',
            'Documento borrado exitosamente.',
            'success'
          );
          this.$router.push({
            name: 'UmesrDetails',
            params: { id: this.id },
          });
        })
        .catch((error) => {
          this.ShowToast('Alerta', error.response.data.message, 'error');
        });
    },
  },
};
</script>
